import React from 'react';
import { Typography } from '@material-ui/core';

import StefanZechmannHero from '../../../../../../../images/test-assignment-zechmann-hero-en.png';

const EN = () => (
  <>
    <img
      src={StefanZechmannHero}
      alt="Order your assigned test"
      className="sidebar__image"
    />
    <div className="sidebar__main-content">
      <Typography variant="body2">
        <br />
        <br />
        You have been assigned a lab test from home by Dr. Stefan Zechmann.
        <br />
        <br />
        Please proceed as follows:
        <br />
        <br />
        <b>1. Order the test</b>
        <br />
        Click on the &quot;Order&quot; button below and go through the checkout
        process.
        <br />
        <br />
        <b>Please note:</b> This is a self-payer service. Reimbursement by basic
        health insurance is not possible.
        <br />
        <br />
        <b>2. Take your test from the comfort of your home</b>
        <br />
        You will receive your test kit 2-3 working days after ordering. It will
        contain an activation code and all the material as well as
        easy-to-follow instructions for taking your sample. You then put your
        test in the provided return box and drop it off in any Swiss post
        mailbox.
        <br />
        <br />
        <b>3. Receive your results</b>
        <br />
        Your sample will be analysed by Medisyn, a leading Swiss laboratory
        provider. Once your results are ready, you will receive an email with a
        link to book your follow-up consultation with Dr. Stefan Zechmann. After
        that consultation, the results will be made available to you online.
      </Typography>
      <button type="button" className="sidebar__button">
        Order assigned test
      </button>
      <Typography variant="body2">
        Should you have any questions or concerns, you can contact us under
        service@yourself.health.
      </Typography>
    </div>
    <div className="sidebar__footer">
      <Typography variant="body2">
        Health Yourself
        <br />
        <br />
        Lerchenfeldstrasse 3, 9014 St. Gallen, Switzerland
        <br />
        <br />
        No longer want to receive these emails? Unsubscribe
        <br />
        <br />© 2025 Health Yourself
      </Typography>
    </div>
  </>
);

export default EN;
